import styled from "styled-components";
import { Color } from "@styles/constants";

export const SubTotalsWrapper = styled.div`
  border-top: 1px solid ${Color.grayLight3};
  padding: 16px 16px;
  display: table;
  text-align: initial;
  width: 100%;
  list-style: none;
  font-size: 14px;
  line-height: 18px;
`;

export const FlexWrapper = styled.li<{ bold?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
`;

export const TextLinkButton = styled.button`
  cursor: pointer;
  text-decoration: underline;
  color: ${Color.black80};
  margin-bottom: 1rem;
  text-align: left;
  height: fit-content;
`;
